// extracted by mini-css-extract-plugin
module.exports = {"container":"HeroShouter-module--container--22WBO","heading":"HeroShouter-module--heading--1s6G-"};